// extracted by mini-css-extract-plugin
module.exports = {"faq__wrapper":"FAQList_faq__wrapper__kot0q","faq__list":"FAQList_faq__list__02Eve"};